import React, { useEffect, useState } from "react";
import API from "../../API";

export const Accounts = () => {
  const [showAdd, setShowAdd] = useState<boolean>(false);
  const [users, setUsers] = useState<any[]>([]);

  const loadUsers = () => {
    API.getUsers().then((data) => {
      setUsers(Array.isArray(data) ? data : []);
    });
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const createNewUser = async (e: any) => {
    e.preventDefault();

    const form = e.currentTarget;
    const response = await API.createUser(
      form.email.value,
      form.username.value,
      form.password.value,
      form.super.value === "true"
    );

    if (response.status === 201) {
      setShowAdd(false);
      alert("Created!");
      loadUsers();
    } else {
      alert("failed, please try again");
    }
  };

  return (
    <div className="accounts_page">
      <div className="accounts_bar">
        <h3 className="accounts_title">Accounts</h3>
        <button className="accounts_add_btn" onClick={() => setShowAdd(true)}>
          + Create New User
        </button>
      </div>

      {users.length === 0 ? (
        <div className="accounts_empty">No users found.</div>
      ) : (
        <div className="accounts_grid">
          {users.map((user, i) => (
            <div className="account_card" key={user.username || i}>
              <div className="account_avatar">
                {(user.username || "?").charAt(0)}
              </div>
              <div className="account_info">
                <div className="account_username" title={user.username}>
                  {user.username}
                </div>
                {user.email && (
                  <div className="account_email" title={user.email}>
                    {user.email}
                  </div>
                )}
                <span
                  className={`account_badge ${
                    user.is_superuser ? "admin" : "standard"
                  }`}
                >
                  {user.is_superuser ? "Admin" : "Standard"}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {showAdd && (
        <form className="account_form" onSubmit={(e) => createNewUser(e)}>
          <h2>Please provide the following information:</h2>
          <div className="account_form_row">
            <label>Email</label>
            <input type="text" name="email" required />
          </div>
          <div className="account_form_row">
            <label>Username</label>
            <input type="text" name="username" required />
          </div>
          <div className="account_form_row">
            <label>Password</label>
            <input type="password" name="password" required />
          </div>
          <div className="account_form_row">
            <label>Is this an admin user?</label>
            <div className="account_radio_group">
              <label>
                <input type="radio" name="super" value="true" required /> Yes
              </label>
              <label>
                <input type="radio" name="super" value="false" defaultChecked />{" "}
                No
              </label>
            </div>
          </div>
          <div className="account_form_actions">
            <button type="submit" className="account_submit_btn">
              Create User
            </button>
            <button
              type="button"
              className="account_cancel_btn"
              onClick={() => setShowAdd(false)}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </div>
  );
};
